var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "3694 11097.816 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "CompositeLayer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3706.5 11097.816c6.904 0 12.5 5.597 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5s-12.5-5.596-12.5-12.5c0-6.903 5.596-12.5 12.5-12.5Z",
    fillRule: "evenodd",
    "data-name": "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3712.78 11109.46h-5.424v-5.425h-1.713v5.425h-5.424v1.712h5.424v5.424h1.713v-5.424h5.424v-1.712Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Page 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.94d6d1143e9189c0a4dae960e96f179d.svg";
export { ForwardRef as ReactComponent };